import { useMutation } from 'react-query';
import { deleteCampaign } from '../request';

interface UseDeleteCampaignProps {
  onSuccess: () => void;
  onError: (e: Error) => void;
}

export const useDeleteCampaign = ({
  onSuccess,
  onError,
}: UseDeleteCampaignProps) => {
  const { isLoading, isError, mutate } = useMutation(
    (campaignId: string) => deleteCampaign(campaignId),
    {
      onSuccess,
      onError,
    }
  );

  return { isLoading, isError, mutate };
};
